<template>
    <div
        aria-hidden="true"
        aria-labelledby="modalFillInLabel"
        class="modal animation opacity modal-video modal-quiz"
        id="modal-quiz"
        role="dialog"
        tabindex="-1"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <figure aria-hidden="true" data-dismiss="modal">
                    <span class="material-symbols-rounded">close</span>
                </figure>
                <div class="modal-header">
                    <figure>
                        <img src="imgs/web/svg/img_de_onboarding_quiz.svg" alt="">
                    </figure>
                </div>
                <div class="modal-body">
                    <h1 class="headline-lg">Der erste Schritt zur&nbsp;Vitadio App</h1>
                    <p class="text-big">Teilen Sie uns ein wenig über sich mit, um zu erfahren, ob Vitadio zu Ihnen passt. Wir helfen Ihnen, den Zugang zur App zu erhalten.</p>
                    <v-button
                        href="#"
                        aria-hidden="true"
                        data-dismiss="modal"
                        size="lg"
                        position="center"
                        label="Weiter"
                        full-width-mobile
                    ></v-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            $("#modal-quiz").modal();
        },
    }
</script>
